import { render, staticRenderFns } from "./listaAvisos.vue?vue&type=template&id=a25ee8b0&scoped=true&"
import script from "./listaAvisos.vue?vue&type=script&lang=js&"
export * from "./listaAvisos.vue?vue&type=script&lang=js&"
import style0 from "./listaAvisos.vue?vue&type=style&index=0&id=a25ee8b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25ee8b0",
  null
  
)

export default component.exports